export default "__VITE_ASSET__BNQkhTns__"